export const sanitizeFilename = (base: string, removeExtension?: boolean): string => {
  // Collapse whitespace
  let cleaned = base.replace(/\s+/g, ' ').trim();

  // Detect simple extension (e.g. .zip, .txt, .csv) and remove it if needed
  const ext = cleaned.match(/(\.[A-Za-z0-9]+)$/)?.[1] || '';
  cleaned = removeExtension ? cleaned.slice(0, cleaned.length - ext.length) : cleaned;

  // Remove characters not allowed on Windows / common file systems
  cleaned = cleaned.replace(/[<>:"/\\|?*#%;@]/g, '');

  // Replace 1+ spaces with a single underscore
  cleaned = cleaned.replace(/ +/g, '_');

  // Prevent empty result
  if (!cleaned || cleaned === '_') cleaned = 'file';

  // Limit length
  if (cleaned.length > 80) cleaned = cleaned.slice(0, 80).trim();

  return cleaned;
};
